/* eslint-disable */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import {
  Table,
  Button,
  Space,
  Typography,
  Modal,
  Form,
  Input,
  InputNumber,
  message,
  Popconfirm,
  Card,
  Row,
  Col,
} from 'antd';
import {
  InboxOutlined,
  PlusOutlined,
  ReloadOutlined,
  EditOutlined,
  DeleteOutlined,
} from '@ant-design/icons';

dayjs.extend(buddhistEra);
dayjs.locale('th');

const { Title, Text } = Typography;

function RefferenceParcel(props) {
  const [form] = Form.useForm();
  const [parcel_list, setParcel_list] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [parcelmode, setParcelmode] = useState('');
  const [currentParcel, setCurrentParcel] = useState(null);

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    getParcelList();
  }, []);

  async function getParcelList() {
    setLoading(true);

    const formData = new FormData();
    formData.append('filter', 'approved');

    axios
      .post(props.app_hostname + '/api/order/parcel/getall', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          setParcel_list(response.data.parcel);
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  function handleAdd() {
    setParcelmode('add');
    setCurrentParcel(null);
    form.resetFields();
    form.setFieldsValue({
      parcel_id: 'สร้างให้อัตโนมัติ',
      parcel_name: '',
      parcel_code: '',
      parcel_width: 0,
      parcel_length: 0,
      parcel_height: 0,
    });
    setIsModalOpen(true);
  }

  function handleEdit(record) {
    setParcelmode('edit');
    setCurrentParcel(record);
    form.setFieldsValue({
      parcel_id: record.parcel_id,
      parcel_name: record.boxsize_name,
      parcel_code: record.parcel_code,
      parcel_width: record.width,
      parcel_length: record.length,
      parcel_height: record.height,
    });
    setIsModalOpen(true);
  }

  async function handleSubmit(values) {
    setModalLoading(true);

    const formData = new FormData();
    formData.append('parcel_id', values.parcel_id);
    formData.append('parcel_name', values.parcel_name);
    formData.append('parcel_code', values.parcel_code);
    formData.append('parcel_width', values.parcel_width);
    formData.append('parcel_length', values.parcel_length);
    formData.append('parcel_height', values.parcel_height);
    formData.append('username', props.permitdata.username);

    if (parcelmode === 'edit' && currentParcel) {
      formData.append('id', currentParcel.id);
    }

    axios
      .post(props.app_hostname + '/api/order/parcel/' + parcelmode, formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setModalLoading(false);
        if (response.data.status === 'OK') {
          setParcel_list(response.data.parcel);
          setIsModalOpen(false);
          message.success('บันทึกข้อมูลกล่องพัสดุสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setModalLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  async function handleDelete(record) {
    setLoading(true);

    const postdata = {
      id: record.id,
    };

    axios
      .post(props.app_hostname + '/api/order/parcel/delete', postdata, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          setParcel_list(response.data.parcel);
          message.success('ลบข้อมูลกล่องพัสดุสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  const columns = [
    {
      title: '#',
      key: 'index',
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: 'รหัสกล่อง',
      dataIndex: 'parcel_code',
      key: 'parcel_code',
      render: (text) => <Text strong>{text || '-'}</Text>,
    },
    {
      title: 'ชื่อกล่องพัสดุ',
      dataIndex: 'boxsize_name',
      key: 'boxsize_name',
      sorter: (a, b) => a.boxsize_name?.localeCompare(b.boxsize_name),
    },
    {
      title: 'ขนาด (กว้าง x ยาว x สูง)',
      key: 'dimension',
      render: (_, record) => `${record.width} x ${record.length} x ${record.height} ซม.`,
    },
    {
      title: 'ปริมาตร (ลบ.ซม.)',
      key: 'volume',
      render: (_, record) => (record.width * record.length * record.height).toLocaleString(),
    },
    {
      title: 'จัดการ',
      key: 'action',
      width: 150,
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            type='primary'
            icon={<EditOutlined />}
            size='small'
            onClick={() => handleEdit(record)}
          >
            แก้ไข
          </Button>
          <Popconfirm
            title='ยืนยันการลบ'
            description='คุณแน่ใจหรือไม่ที่จะลบกล่องพัสดุนี้?'
            onConfirm={() => handleDelete(record)}
            okText='ตกลง'
            cancelText='ยกเลิก'
          >
            <Button type='primary' danger icon={<DeleteOutlined />} size='small'>
              ลบ
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className='page-wrapper'>
      <div className='page-card'>
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
          <div className='page-header-actions'>
            <div>
              <Title level={3} style={{ margin: 0 }}>
                <InboxOutlined style={{ color: '#1890ff', marginRight: '8px' }} />
                ข้อมูลกล่องพัสดุ (Parcel)
              </Title>
              <Text type='secondary'>จัดการขนาดและประเภทกล่องพัสดุทั้งหมด</Text>
            </div>
            <Space>
              <Button icon={<PlusOutlined />} type='primary' onClick={handleAdd}>
                เพิ่มใหม่
              </Button>
              <Button icon={<ReloadOutlined />} onClick={getParcelList} loading={loading}>
                รีเฟรช
              </Button>
            </Space>
          </div>

          <div style={{ marginTop: '24px' }}>
            <Title level={5} style={{ marginBottom: '16px' }}>
              รายการกล่องพัสดุ <span>({parcel_list.length} รายการ)</span>
            </Title>

            {/* Desktop Table View */}
            <div className='accountshop-desktop-view'>
              <Table
                columns={columns}
                dataSource={parcel_list}
                rowKey='parcel_id'
                loading={loading}
                pagination={{ pageSize: 10, showTotal: (total) => `รวม ${total} รายการ` }}
                scroll={{ x: 'max-content' }}
              />
            </div>

            {/* Mobile Card View */}
            <div className='accountshop-mobile-view'>
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '4px 0' }}
              >
                {parcel_list.map((item) => (
                  <Card
                    key={item.parcel_id || item.id}
                    size='small'
                    style={{ borderRadius: '12px', border: '1px solid #e2e8f0' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                      }}
                    >
                      <div>
                        <Text strong style={{ fontSize: '15px', color: '#1e293b' }}>
                          {item.boxsize_name}
                        </Text>
                        <br />
                        <Text type='secondary' style={{ fontSize: '13px' }}>
                          รหัสโค้ด: {item.parcel_code || '-'}
                        </Text>
                        <br />
                        <Text style={{ fontSize: '12px', color: '#475569' }}>
                          ขนาด: {item.width} x {item.length} x {item.height} ซม.
                        </Text>
                      </div>
                      <Space>
                        <Button
                          type='primary'
                          icon={<EditOutlined />}
                          size='small'
                          onClick={() => handleEdit(item)}
                        >
                          แก้ไข
                        </Button>
                        <Popconfirm
                          title='ยืนยันการลบ'
                          description='คุณแน่ใจหรือไม่ที่จะลบกล่องพัสดุนี้?'
                          onConfirm={() => handleDelete(item)}
                          okText='ตกลง'
                          cancelText='ยกเลิก'
                        >
                          <Button type='primary' danger icon={<DeleteOutlined />} size='small'>
                            ลบ
                          </Button>
                        </Popconfirm>
                      </Space>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </Space>
      </div>

      <Modal
        title={
          <Space>
            <InboxOutlined />
            {parcelmode === 'add' ? 'เพิ่มกล่องพัสดุ' : 'แก้ไขกล่องพัสดุ'}
          </Space>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={600}
        centered
      >
        <Form form={form} layout='vertical' onFinish={handleSubmit} style={{ marginTop: '24px' }}>
          <Form.Item name='parcel_id' label='รหัสกล่องพัสดุ'>
            <Input disabled />
          </Form.Item>

          <Form.Item
            name='parcel_name'
            label='ชื่อกล่องพัสดุ'
            rules={[
              { required: true, message: 'กรุณากรอกชื่อกล่องพัสดุ' },
              { min: 3, message: 'อย่างน้อย 3 ตัวอักษร' },
            ]}
          >
            <Input placeholder='กรอกชื่อกล่องพัสดุ' />
          </Form.Item>

          <Form.Item
            name='parcel_code'
            label='รหัสโค้ดพัสดุ'
            rules={[{ required: true, message: 'กรุณากรอกรหัสโค้ดพัสดุ' }]}
          >
            <Input placeholder='กรอกรหัสโค้ดพัสดุ' />
          </Form.Item>

          <Row gutter={16}>
            <Col xs={24} sm={8}>
              <Form.Item
                name='parcel_width'
                label='ความกว้าง (ซม.)'
                rules={[{ required: true, message: 'กรุณากรอกความกว้าง' }]}
              >
                <InputNumber min={1} style={{ width: '100%' }} placeholder='0' />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name='parcel_length'
                label='ความยาว (ซม.)'
                rules={[{ required: true, message: 'กรุณากรอกความยาว' }]}
              >
                <InputNumber min={1} style={{ width: '100%' }} placeholder='0' />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name='parcel_height'
                label='ความสูง (ซม.)'
                rules={[{ required: true, message: 'กรุณากรอกความสูง' }]}
              >
                <InputNumber min={1} style={{ width: '100%' }} placeholder='0' />
              </Form.Item>
            </Col>
          </Row>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '8px',
              marginTop: '24px',
            }}
          >
            <Button onClick={() => setIsModalOpen(false)}>ยกเลิก</Button>
            <Button type='primary' htmlType='submit' loading={modalLoading}>
              บันทึก
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
}

export default RefferenceParcel;
